import React from 'react';
import { Shield, Lock, Database, Eye, Server, Heart } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-8 py-16">

        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-6 h-6 text-primary" />
            <span className="text-xs uppercase tracking-widest text-muted-foreground font-['IBM_Plex_Sans']">
              Privacy Promise
            </span>
          </div>
          <h1 className="text-5xl font-bold tracking-tight mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Your data is yours. Full stop.
          </h1>
          <p className="text-lg text-muted-foreground font-['IBM_Plex_Sans'] leading-relaxed">
            BAflow is a free tool built for professionals. We have no interest in your data beyond making the product work for you.
          </p>
        </div>

        {/* Commitments */}
        <div className="space-y-8 mb-16">

          <div className="flex gap-6 p-6 bg-card border border-border rounded-sm">
            <Database className="w-5 h-5 text-primary shrink-0 mt-1" />
            <div>
              <h2 className="font-bold tracking-tight mb-2">We never sell your data</h2>
              <p className="text-muted-foreground font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                Your requirements, documents, analysis, and work are never sold, rented, or traded to any third party — ever. That includes data brokers, advertisers, and analytics companies.
              </p>
            </div>
          </div>

          <div className="flex gap-6 p-6 bg-card border border-border rounded-sm">
            <Server className="w-5 h-5 text-primary shrink-0 mt-1" />
            <div>
              <h2 className="font-bold tracking-tight mb-2">Your work stays on our server — nowhere else</h2>
              <p className="text-muted-foreground font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                Everything you save is stored on our private server. It is not shared with OpenAI, Google, or any external AI provider. The AI features in this tool run locally — your content does not leave our infrastructure.
              </p>
            </div>
          </div>

          <div className="flex gap-6 p-6 bg-card border border-border rounded-sm">
            <Eye className="w-5 h-5 text-primary shrink-0 mt-1" />
            <div>
              <h2 className="font-bold tracking-tight mb-2">We do not read your work</h2>
              <p className="text-muted-foreground font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                We do not access, review, or monitor the content of your documents, requirements, or analysis. Your business information is private.
              </p>
            </div>
          </div>

          <div className="flex gap-6 p-6 bg-card border border-border rounded-sm">
            <Lock className="w-5 h-5 text-primary shrink-0 mt-1" />
            <div>
              <h2 className="font-bold tracking-tight mb-2">What we store and why</h2>
              <p className="text-muted-foreground font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                We store your email address and name (to identify your account), and the work you explicitly save inside the tool. We do not track your behaviour across the web, and we do not use third-party advertising trackers.
              </p>
            </div>
          </div>

          <div className="flex gap-6 p-6 bg-card border border-border rounded-sm">
            <Heart className="w-5 h-5 text-primary shrink-0 mt-1" />
            <div>
              <h2 className="font-bold tracking-tight mb-2">This tool is free — and will stay honest</h2>
              <p className="text-muted-foreground font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                BAflow is offered free of charge. We are not funded by advertising. We do not monetise your data. The only reason we collect anything is to make the product function.
              </p>
            </div>
          </div>

        </div>

        {/* Contact */}
        <div className="border-t border-border pt-10">
          <p className="text-sm text-muted-foreground font-['IBM_Plex_Sans'] leading-relaxed">
            Questions about your data or how this works? Reach out at{' '}
            <span className="text-foreground font-medium">privacy@baflow.uk</span>. We will always respond.
          </p>
          <p className="text-xs text-muted-foreground font-['IBM_Plex_Sans'] mt-4">
            Last updated: April 2026
          </p>
        </div>

      </div>
    </div>
  );
}
